import _ from 'lodash';

export const handleTitle = (packet) => {
  const { sub_conditions } = packet;
  let str = ''
  sub_conditions.map((item) => {
    str += `${handleConditionType(item.condition_type)}${handleOperator(item.relationship)}${item.threshold || item.condition_value}${handleConditionUnit(item.condition_type)}且`
  })
  str = str.substring(0, str.length - 1);
  return str
}

export const handleTitleV2 = (packet) => {
  const sub_conditions = _.cloneDeep(packet.sub_conditions);
  let str = ''
  sub_conditions.sort((a, b) => {
    if (a.condition_type == 4) {
      return -1;
    } else if (a.condition_type < b.condition_type) {
      return -1
    }else {
      return 1
    }
  });
  sub_conditions.map((item) => {    
      str += `${handleDate(item)}${handleConditionTypeV2(item.condition_type, item.value_type)}${handleOperator(item.relationship)}${item.threshold || item.condition_value}${handleConditionUnit(item.condition_type)}且`
  })
  str = str.substring(0, str.length - 1);
  return str
}

// 处理规则类型
export const handleConditionUnit = (conditionType) => {
  switch (conditionType) { 
    case 1:
      return '级'
    case 2:
      return '元'
    case 4:
      return '天';
    default:
      return ''
  }
}

export const handlePrice = (packet) =>  {
  if (packet.money) {
    return packet.money
  } else if (packet.show_max || packet.show_min) {
    if (packet.show_max && !packet.show_min) {
      return `最高领取${packet.show_max}`
    } else {
      return `随机领取${packet.show_min}元-${packet.show_max}`
    }
  } else {
    const moneyOptions = packet.money_options;
    let max = 0;
    moneyOptions.map((item) => {
      if (item.max > max) max = item.max;
    })
    return `最高领取${max}`
  }
}

export const handleConditionType = (conditionType) => {
  switch (conditionType) { 
    case 1:
      return '等级'
    case 2:
      return '充值'
    case 3:
      return '战力'
  }
}

export const handleConditionTypeV2 = (conditionType, valueType) => {
  switch (conditionType) {
    case 1:
      return '等级';
    case 2:
      return valueType == 1 ? '单笔充值' : '累计充值';
    case 4:
      return valueType == 1 ? '连续登录' : '累计登录';
  }
}

export const handleOperator = (operator) => {
  switch (operator) { 
    case '>':
      return '超过'
    case '=':
      return ''
    default:
      return '达到';
  }
}

export const handleDate = (item) => {
  if (item.role_create_begin == 0 && item.role_created_end == 0) return '';
  if (!item.role_create_begin || !item.role_created_end) return '';
  if (item.role_create_begin == item.role_created_end) return `创角第${item.role_create_begin}日`;
  return `创角第${item.role_create_begin}日-第${item.role_created_end}日`;
}